import React, { useEffect, useState } from 'react';
import { api, apiError } from '../api/client';
import { Button } from './ui';

export default function TokenQuotaSummary({ paused = false }) {
  const [quota, setQuota] = useState(null);
  const [error, setError] = useState('');
  const [revision, setRevision] = useState(0);
  useEffect(() => {
    let active = true;
    const load = () => api.getMyTokenQuota().then(q => { if (active) { setQuota(q); setError(''); } }).catch(e => { if (active) setError(apiError(e)); });
    load();
    const timer = setInterval(load, 15000);
    return () => { active = false; clearInterval(timer); };
  }, [revision]);
  return <section className="card" aria-label="Использование доступного объёма" style={{ marginBottom: 16 }}>
    <h2 className="card-title">Использование доступного объёма</h2>
    {paused && <p role="status">Работа ожидает обновления лимита клиента. Текущее состояние сохранено. Продолжение произойдёт автоматически после сброса или увеличения доступного объёма.</p>}
    {error && <p role="alert">{error} <Button className="btn btn-sm" onClick={() => setRevision(x => x + 1)}>Повторить</Button></p>}
    {quota ? quota.mode === 'unlimited' ? <p>Без ограничений</p> : <>
      <p>Использовано {quota.used_percent}% доступного объёма за период.</p>
      <progress aria-label="Использовано доступного объёма" max="100" value={quota.used_percent} style={{ width: '100%' }} />
      {quota.availability === 'temporarily_busy' && <p role="status">Доступный объём временно занят выполняющимися задачами.</p>}
      {quota.availability === 'exhausted' && <p role="status">Доступный объём исчерпан.</p>}
      {quota.resets_at && <p className="text-muted">Обновление доступного объёма: {new Date(quota.resets_at).toLocaleString('ru-RU', { timeZone: 'Europe/Moscow' })} МСК.</p>}
    </> : !error && <p>Загрузка…</p>}
  </section>;
}
